/**
 * True only in a real Node.js runtime. `process.versions.node` is set by Node and
 * absent in browsers and non-Node edge runtimes, so this stays correct even when a
 * server has installed a jsdom `window` (e.g. BlockNote's server DOM shim).
 * @returns {boolean}
 */
const isNodeRuntime = () => typeof process !== 'undefined' && process.versions?.node != null;

/**
 * Running in a real browser?
 *
 * Default: the historical check, true whenever a `window` exists. With
 * `excludeServerRuntime`, also require that we are NOT in a Node process, so a
 * server that has installed a DOM (e.g. BlockNote's jsdom shim) is treated as a
 * server, not a browser. Server-only guards pass this.
 *
 * @param {{ excludeServerRuntime?: boolean }} [options]
 * @returns {boolean}
 */
export const isBrowser = (options) => {
  if (typeof window === 'undefined') return false;
  if (options?.excludeServerRuntime && isNodeRuntime()) return false;
  return true;
};

/**
 * Check if the code is running on the server.
 *
 * Note: this is the literal inverse of the default `isBrowser()`, so it has the
 * same blind spot under a server-installed jsdom `window` (returns false). No
 * guard depends on it today; use `isBrowser({ excludeServerRuntime: true })` when
 * that distinction matters.
 * @returns {boolean}
 */
export const isServer = () => typeof window === 'undefined';
